/**
 * Created by Ning Jiang on 2/7/2018.
 */

import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {StepCountUpBigWinController} from "@nolimitcity/slot-game/bin/game/winpresentation/bigwin/stepcountup/StepCountUpBigWinController";
import {Timeline} from "gsap";
import {CreepyCarnivalTwoGameConfig} from "../../CreepyCarnivalTwoGameConfig";
import {CreepyCarnivalTwoSoundConfig} from "../../CreepyCarnivalTwoSoundConfig";
import {CCTwoMultiplierEvents} from "../../multiplier/CCTwoMultiplierEvents";
import {CreepyCarnivalTwoParsedGameData} from "../../server/data/CreepyCarnivalTwoParsedGameData";
import {CreepyCarnivalBulbsEvent} from "../../utils/CCTwoBulb";
import {CreepyCarnivalTwoBigWinCountUp} from "./CreepyCarnivalTwoBigWinCountUp";
import {CreepyCarnivalTwoBigWinView} from "./CreepyCarnivalTwoBigWinView";

export class CreepyCarnivalTwoBigWinController extends StepCountUpBigWinController {

    private _gameView:CreepyCarnivalTwoBigWinView;
    private _winCountUp:CreepyCarnivalTwoBigWinCountUp;
    protected _gameData:CreepyCarnivalTwoParsedGameData;
    private _soundPlayed:boolean = false;
    private _totalwin:number;
    private _singleWin:number;

    constructor(indexes:[number, number]) {
        super(indexes, {skipLastLevelCountUpIfSmall : true});

        this._gameView = new CreepyCarnivalTwoBigWinView();
        this._winCountUp = new CreepyCarnivalTwoBigWinCountUp();
        this._winCountUp.position.set(GameConfig.instance.GAME_WIDTH * 0.5, GameConfig.instance.GAME_HEIGHT * 0.58);
        StageManager.getLayer(CreepyCarnivalTwoGameConfig.instance.LAYERS.WIN_COUNT_UP.name).addChild(this._winCountUp);
    }

    protected parseFeatureGameData(data:CreepyCarnivalTwoParsedGameData):void {
        super.parseFeatureGameData(data);

        this._gameData = data;
        this._totalwin = data.totalWin;
        this._singleWin = data.singleWin;
    }

    protected getBigWinLevelAnimation(level:number):Timeline {
        if(level > 0) { // #218
            EventHandler.dispatchEvent(new GameEvent(CCTwoMultiplierEvents.APPLY_MULTIPLIER));
        }

        EventHandler.dispatchEvent(new GameEvent(CreepyCarnivalBulbsEvent.SHOW_YELLOW_BULBS_FOR_BIG_WIN));
        return this._gameView.getBigWinLevelAnimation(this._winRatios[level], level);
    }

    protected playCountUp(from:number, to:number, duration:number, preTotalWin:number = 0):Timeline | null {
        return this._winCountUp.getCountUpAnimation(from, to, duration, this._gameData.multiplier, this._totalwin, this._singleWin);
    }

    protected playEndingAnimation(isAborted:boolean):void {
        this._gameView.playEndingAnimation(this._winRatios[this._winLevel], this._gameData.mode, isAborted);
        SlotGame.winFieldController.showWinField(this._gameData.totalWin);
        this._winCountUp.abort(this._gameData.singleWin, isAborted);
    }

    protected playBigWinSound():void {
        SlotGame.sound.fadeAmbience(0, 0);
        SlotGame.sound.playEffect(CreepyCarnivalTwoSoundConfig.instance.BIGWIN);
        this._soundPlayed = true;
    }

    protected stopAllSounds():void {
        if(this._soundPlayed) {
            SlotGame.sound.fadeAmbience(1, 5000);
            SlotGame.sound.stopEffect(CreepyCarnivalTwoSoundConfig.instance.BIGWIN);
            SlotGame.sound.playEffect(CreepyCarnivalTwoSoundConfig.instance.BIGWIN_ENDS);

            this._soundPlayed = false;
        }
    }
}